<template>
  <div class="admin">
    <el-container>
      <el-aside width="200px">
        <el-menu :default-active="defaultActive" class="el-menu-vertical-demo" router>
          <template v-for="(item, index) in menus">
            <el-menu-item :index="item.index" :key="index">
              <i :class="item.icon"></i>
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </el-aside>
      <el-container>
        <el-main>
          <div class="base-padding">
            <router-view />
          </div>
        </el-main>
        <!-- <el-footer>2019@交大神舟版权所有</el-footer> -->
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "admin",
  data() {
    return {
      defaultActive: "/",
      menus: [
        // {
        //   name: "轮播图管理",
        //   index: "/admin/banner",
        //   icon: "el-icon-picture-outline",
        // },
        {
          name: "专用车辆与装备管理",
          index: "/admin/product",
          icon: "el-icon-printer",
        },
        {
          name: "智能化系统管理",
          index: "/admin/intelligentize-system",
          icon: "el-icon-cpu",
        },
        {
          name: "新闻资讯管理",
          index: "/admin/news",
          icon: "el-icon-news",
        },
        {
          name: "招贤纳士管理",
          index: "/admin/invite",
          icon: "el-icon-receiving",
        },
        {
          name: "客户服务管理",
          index: "/admin/client",
          icon: "el-icon-service",
        },
        // {
        //   name: "案例信息管理",
        //   index: "/admin/cases",
        //   icon: "el-icon-document",
        // },
        {
          name: "团队风采管理",
          index: "/admin/team",
          icon: "el-icon-camera",
        },
        {
          name: "发展历程管理",
          index: "/admin/course",
          icon: "el-icon-time",
        },
        // {
        //   name: "合作企业管理",
        //   index: "/admin/enterprise",
        //   icon: "el-icon-office-building",
        // },
        {
          name: "荣誉墙管理",
          index: "/admin/honor",
          icon: "el-icon-trophy",
        },
        {
          name: "数据字典管理",
          index: "/admin/dictionary",
          icon: "el-icon-setting",
        },
      ],
    };
  },
  mounted() {

    this.http
      .get(`/index`)
      .then(response => {
        //console.log(response);
      })

    let hash = window.location.hash.replace("#", "");

    if (hash == '/admin') {
      this.defaultActive = this.menus[0].index;
      // this.$router.push({ name: "adminBanner" });
      this.$router.push({ name: "adminProduct" });
      return;
    }

    let menu = this.menus.find(item => hash == item.index);
    if (menu) {
      this.defaultActive = hash;
    } else {
      this.defaultActive = null;
    }
  },
};
</script>

<style lang="scss" soped>
.admin {
  border-top: 1px solid rgb(238, 238, 238);
}

.base-padding {
  padding: 20px;
}

.el-footer {
  line-height: 60px;
}
</style>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>